import submissionService from '../../services/submissionService';
import { showNotification } from '../reducers/uiReducer';

// Types d'actions
export const FETCH_SUBMISSIONS_REQUEST = 'FETCH_SUBMISSIONS_REQUEST';
export const FETCH_SUBMISSIONS_SUCCESS = 'FETCH_SUBMISSIONS_SUCCESS';
export const FETCH_SUBMISSIONS_FAILURE = 'FETCH_SUBMISSIONS_FAILURE';

export const FETCH_SUBMISSION_REQUEST = 'FETCH_SUBMISSION_REQUEST';
export const FETCH_SUBMISSION_SUCCESS = 'FETCH_SUBMISSION_SUCCESS';
export const FETCH_SUBMISSION_FAILURE = 'FETCH_SUBMISSION_FAILURE';

export const CREATE_SUBMISSION_REQUEST = 'CREATE_SUBMISSION_REQUEST';
export const CREATE_SUBMISSION_SUCCESS = 'CREATE_SUBMISSION_SUCCESS';
export const CREATE_SUBMISSION_FAILURE = 'CREATE_SUBMISSION_FAILURE';

export const UPDATE_SUBMISSION_REQUEST = 'UPDATE_SUBMISSION_REQUEST';
export const UPDATE_SUBMISSION_SUCCESS = 'UPDATE_SUBMISSION_SUCCESS';
export const UPDATE_SUBMISSION_FAILURE = 'UPDATE_SUBMISSION_FAILURE';

export const DELETE_SUBMISSION_REQUEST = 'DELETE_SUBMISSION_REQUEST';
export const DELETE_SUBMISSION_SUCCESS = 'DELETE_SUBMISSION_SUCCESS';
export const DELETE_SUBMISSION_FAILURE = 'DELETE_SUBMISSION_FAILURE';

export const APPEND_SUBMISSIONS_REQUEST = 'APPEND_SUBMISSIONS_REQUEST';
export const APPEND_SUBMISSIONS_SUCCESS = 'APPEND_SUBMISSIONS_SUCCESS';
export const APPEND_SUBMISSIONS_FAILURE = 'APPEND_SUBMISSIONS_FAILURE';

export const CLEAR_SUBMISSION            = 'CLEAR_SUBMISSION';
export const CLEAR_SUBMISSION_ERRORS     = 'CLEAR_SUBMISSION_ERRORS';
export const REMOVE_SUBMISSION_FROM_LIST = 'REMOVE_SUBMISSION_FROM_LIST';

// Actions creators
export const fetchSubmissionsRequest = () => ({
  type: FETCH_SUBMISSIONS_REQUEST
});

export const fetchSubmissionsSuccess = (submissions) => ({
  type: FETCH_SUBMISSIONS_SUCCESS,
  payload: submissions
});

export const fetchSubmissionsFailure = (error) => ({
  type: FETCH_SUBMISSIONS_FAILURE,
  payload: error
});

export const fetchSubmissionRequest = () => ({
  type: FETCH_SUBMISSION_REQUEST
});

export const fetchSubmissionSuccess = (submission) => ({
  type: FETCH_SUBMISSION_SUCCESS,
  payload: submission
});

export const fetchSubmissionFailure = (error) => ({
  type: FETCH_SUBMISSION_FAILURE,
  payload: error
});

export const createSubmissionRequest = () => ({
  type: CREATE_SUBMISSION_REQUEST
});

export const createSubmissionSuccess = (submission) => ({
  type: CREATE_SUBMISSION_SUCCESS,
  payload: submission
});

export const createSubmissionFailure = (error) => ({
  type: CREATE_SUBMISSION_FAILURE,
  payload: error
});

export const updateSubmissionRequest = () => ({
  type: UPDATE_SUBMISSION_REQUEST
});

export const updateSubmissionSuccess = (submission) => ({
  type: UPDATE_SUBMISSION_SUCCESS,
  payload: submission
});

export const updateSubmissionFailure = (error) => ({
  type: UPDATE_SUBMISSION_FAILURE,
  payload: error
});

export const deleteSubmissionRequest = () => ({
  type: DELETE_SUBMISSION_REQUEST
});

export const deleteSubmissionSuccess = (submissionId) => ({
  type: DELETE_SUBMISSION_SUCCESS,
  payload: submissionId
});

export const deleteSubmissionFailure = (error) => ({
  type: DELETE_SUBMISSION_FAILURE,
  payload: error
});

export const clearSubmission = () => ({
  type: CLEAR_SUBMISSION
});

export const clearSubmissionErrors = () => ({
  type: CLEAR_SUBMISSION_ERRORS
});

export const removeSubmissionFromList = (submissionId) => ({
  type: REMOVE_SUBMISSION_FROM_LIST,
  payload: submissionId
});

// Action creator asynchrones 
export const getSubmissions = (params) => async (dispatch) => {
  try {
    dispatch(fetchSubmissionsRequest());

    const response = await submissionService.getSubmissions(params);

    const formattedData = {
      items: response.submissions || [],
      pagination: response.pagination || {}
    };

    dispatch(fetchSubmissionsSuccess(formattedData));
    return Promise.resolve(formattedData);
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Erreur lors de la récupération des soumissions';
    dispatch(fetchSubmissionsFailure(errorMessage));
    dispatch(showNotification({ type: 'error', title: 'Erreur', message: errorMessage }));
    return Promise.reject(error);
  }
};

export const loadMoreSubmissions = (params) => async (dispatch) => {
  try {
    dispatch({ type: APPEND_SUBMISSIONS_REQUEST });

    const response = await submissionService.getSubmissions(params);

    const formattedData = {
      items: response.submissions || [],
      pagination: response.pagination || {}
    };

    dispatch({ type: APPEND_SUBMISSIONS_SUCCESS, payload: formattedData });
    return Promise.resolve(formattedData);
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Erreur lors du chargement';
    dispatch({ type: APPEND_SUBMISSIONS_FAILURE, payload: errorMessage });
    return Promise.reject(error);
  }
};

export const getSubmissionById = (submissionId) => async (dispatch) => {
  try {
    dispatch(fetchSubmissionRequest());
    
    const response = await submissionService.getSubmissionById(submissionId);
    
    dispatch(fetchSubmissionSuccess(response.submission));
    return Promise.resolve(response);
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Erreur lors de la récupération de la soumission';
    dispatch(fetchSubmissionFailure(errorMessage));
    
    dispatch(showNotification({
      type: 'error',
      title: 'Erreur',
      message: errorMessage
    }));
    
    return Promise.reject(error);
  }
};

export const createSubmission = (submissionData) => async (dispatch) => {
  try {
    dispatch(createSubmissionRequest());
    
    const response = await submissionService.createSubmission(submissionData);
    
    dispatch(createSubmissionSuccess(response.submission));
    
    dispatch(showNotification({
      type: 'success',
      title: 'Succès',
      message: 'Soumission créée avec succès'
    }));
    
    return Promise.resolve(response);
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Erreur lors de la création de la soumission';
    dispatch(createSubmissionFailure(errorMessage));
    
    dispatch(showNotification({
      type: 'error',
      title: 'Erreur',
      message: errorMessage
    }));
    
    return Promise.reject(error);
  }
};

export const updateSubmission = (submissionId, submissionData) => async (dispatch) => {
  try {
    dispatch(updateSubmissionRequest());
    
    const response = await submissionService.updateSubmission(submissionId, submissionData);
    
    dispatch(updateSubmissionSuccess(response.submission));
    
    dispatch(showNotification({
      type: 'success',
      title: 'Succès',
      message: 'Soumission mise à jour avec succès'
    }));
    
    return Promise.resolve(response);
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Erreur lors de la mise à jour de la soumission';
    dispatch(updateSubmissionFailure(errorMessage));
    
    dispatch(showNotification({
      type: 'error',
      title: 'Erreur',
      message: errorMessage
    }));
    
    return Promise.reject(error);
  }
};

export const deleteSubmission = (submissionId) => async (dispatch) => {
  try {
    dispatch(deleteSubmissionRequest());
    
    await submissionService.deleteSubmission(submissionId);
    
    dispatch(deleteSubmissionSuccess(submissionId));
    
    dispatch(showNotification({
      type: 'success',
      title: 'Succès',
      message: 'Soumission supprimée avec succès'
    }));
    
    return Promise.resolve();
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Erreur lors de la suppression de la soumission';
    dispatch(deleteSubmissionFailure(errorMessage));
    
    dispatch(showNotification({
      type: 'error',
      title: 'Erreur',
      message: errorMessage
    }));
    
    return Promise.reject(error);
  }
};